// extracted by mini-css-extract-plugin
export default {"home":"c-i_eh","home__background":"c-i_ei","home__content":"c-i_ej"};